webpackJsonp([144378635789046],{

/***/ 1363:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"I Can Do Things That Are Hard: How Learning to Code Changed My Life","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/i-can-do-things-that-are-hard-how-learning-to-code-changed-my-life","createdAt":"2017-07-27T20:57:50.955Z","blogAuthor":{"fields":{"name":"Jake Hawken","slug":"blog/author/jake-hawken"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/7E54zSh1231zhsrqZLfWl0/55e2fd2254fa92cf94f6262dda3fba7a/jake_final.jpg"}}}}}]},"authorJson":{"name":"Jake Hawken","slug":"blog/author/jake-hawken","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/jake-hawken"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-jake-hawken-bff7e18b70b9a73d8bde.js